import React from "react";
import Styles from "./ChangePass.module.scss";
import clsx from "clsx";
import { Controller } from "react-hook-form";
import { LoginInput } from "../../../Components/Atoms/LoginInput";
import MenuVTC from "../../../Share/Component/MenuVtc";
import useChangePassPage from "../../../Hooks/useChangePassPage";
import ReCaptcha from "../../../Components/Molecules/ReCaptcha";

function ChangPass() {
  const {
    control,
    handleSubmit,
    handleGetVerifyCode,
    isSentVerify,
    isSendingVerify,
    pageLoading,
    version,
    reCaptchaV2,
    isLoadReCaptChaV3,
    recaptchaLoading,
    recaptchaError,
    isDefaultV3,
    loading,
  } = useChangePassPage();

  const isFormDisabled = pageLoading || loading;

  return (
    <>
      <div className={clsx(Styles.main)}>
        <div className={clsx(Styles.formBox)}>
          <div className={clsx(Styles.formValue)}>
            <h2>ĐỔI MẬT KHẨU</h2>

            <form onSubmit={handleSubmit} className={clsx(Styles.form)}>
              <Controller
                name="accountName"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="TÀI KHOẢN"
                    name="accountName"
                    id="accountName"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    isDisable={true}
                  />
                )}
              />

              <Controller
                name="oldPassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="MẬT KHẨU"
                    id="oldPassword"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    type="password"
                    isDisable={pageLoading}
                  />
                )}
              />

              <Controller
                name="newPassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="MẬT KHẨU MỚI"
                    id="newPassword"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    type="password"
                    isDisable={pageLoading}
                  />
                )}
              />
              <Controller
                name="rePassword"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="NHẬP LẠI MẬT KHẨU"
                    id="rePassword"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    type="password"
                    isDisable={pageLoading}
                  />
                )}
              />

              <Controller
                name="verifyCode"
                control={control}
                render={({ field, fieldState: { error } }) => (
                  <LoginInput
                    label="MÃ XÁC NHẬN"
                    name="verifyCode"
                    value={field.value}
                    onChange={field.onChange}
                    error={error}
                    isDisable={pageLoading}
                  />
                )}
              />

              <ReCaptcha
                version={version}
                isDefaultV3={isDefaultV3}
                reCaptchaV2={reCaptchaV2}
                recaptchaLoading={recaptchaLoading}
                recaptchaError={recaptchaError}
                isLoadReCaptChaV3={isLoadReCaptChaV3}
              />

              <button
                className={clsx(Styles.btnSubmit, {
                  [Styles.disabled]: isFormDisabled,
                })}
                type="submit"
                disabled={isFormDisabled}
              >
                {pageLoading
                  ? "Đang tải thông tin..."
                  : loading
                    ? "Đang xử lý..."
                    : "Xác nhận"}
              </button>
              <button
                type="button"
                className={clsx(Styles.resendCodeLink, {
                  [Styles.resendCodeLinkDisabled]:
                    pageLoading || isSentVerify || isSendingVerify,
                })}
                onClick={handleGetVerifyCode}
                disabled={pageLoading || isSentVerify || isSendingVerify}
              >
                {isSendingVerify
                  ? "Đang gửi mã xác nhận..."
                  : isSentVerify
                    ? "Mã xác nhận đã được gửi"
                    : "Lấy mã xác nhận!"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <MenuVTC />
    </>
  );
}
export default ChangPass;
